var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7144 31.4286C24.3932 31.4286 31.4287 24.393 31.4287 15.7143C31.4287 14.7307 31.3383 13.7682 31.1654 12.8347C30.2319 12.6618 29.2694 12.5714 28.2858 12.5714C19.6071 12.5714 12.5715 19.6069 12.5715 28.2857C12.5715 29.2693 12.6619 30.2318 12.8348 31.1653C13.7683 31.3382 14.7308 31.4286 15.7144 31.4286Z",
    fill: "#175CD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8347 31.1653C5.53118 29.8127 0 23.4095 0 15.7143C0 7.03553 7.03554 0 15.7143 0C23.4095 0 29.8128 5.53118 31.1654 12.8347C30.2318 12.6618 29.2694 12.5714 28.2858 12.5714C19.607 12.5714 12.5714 19.607 12.5714 28.2857C12.5714 29.2693 12.6618 30.2318 12.8347 31.1653Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7143 31.4285C24.3931 31.4285 31.4286 24.393 31.4286 15.7142C31.4286 14.7306 31.3383 13.7681 31.1654 12.8346C38.4689 14.1872 44.0001 20.5905 44.0001 28.2856C44.0001 36.9644 36.9645 43.9999 28.2858 43.9999C20.5906 43.9999 14.1873 38.4687 12.8347 31.1652C13.7682 31.3381 14.7307 31.4285 15.7143 31.4285Z",
    fill: "#2E90FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login_logo.1ed9e48e57ba53dde71799dbd6119971.svg";
export { ForwardRef as ReactComponent };